import axios from 'axios'

export const IsAuthorized = (error) => {
  if (axios.isAxiosError(error)) {
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      console.log("IsAuthorized error status", error?.response?.status);
      
    }
  }
}
      // localStorage.clear()
      // const currentUrl = new URL(window.location.href)
      // window.location.href = currentUrl.origin